import * as ser from '../Common/SerUtil.js'

/**
 * Helper class for a 12x24 map of values.
 * Note that using a flat map with get/set [mo,hr] will be behave as expected.
 */
export class MonthHourMap {
  static serInfo = {
    type: 'MonthHourMap',
  }

  constructor() {
    this.data = new Map();

    this.serFields = [
      ser.staticField('_type', 'MonthHourMap'),
      'data',
    ];
  }

  set(month, hour, value) {
    if (!this.data.has(month)) {
      this.data.set(month, new Map());
    }
    this.data.get(month).set(hour, value);
  }

  get(month, hour) {
    return this.data.get(month)?.get(hour);
  }

  has(month, hour) {
    return this.data.get(month)?.has(hour) || false;
  }

  delete(month, hour) {
    const hourMap = this.data.get(month);
    if (hourMap) {
      hourMap.delete(hour);
      if (hourMap.size === 0) {
        this.data.delete(month); // clean up if empty
      }
    }
  }
}
